module.exports = __webpack_public_path__ + "static/media/VOCAB-01.1a7bab5c.png";